module.exports = __webpack_public_path__ + "img/600w户外.ee2dda75.png";